<template>
    <main>
        <slot name="header">
            <section class="flex justify-between w-full items-center mb-4">
                <h5 class="mr-6"><strong class="text-primary">Qurban</strong></h5>
                <router-link to="/zxcare/qurban" class="text-primary">
                    <small>Lihat Semua &nbsp;&nbsp;&nbsp;>></small>
                </router-link>
            </section>
        </slot>

        <!-- Content -->
        <div>
			<swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                <swiper-slide
                    v-for="(item, i) in datas"
                    :key="i"
                >
                <vx-card class="mb-6 rounded">
					<div
                        :style="{ backgroundImage: `url('${imageLink(item)}')`, backgroundSize: 'cover' }" 
                        class="cursor-pointer image-container h-56 md:h-64 rounded"  
                        slot="no-body"
                        @click="$router.push(`/qurban/view/${ createSlugLink(item.name, item.id) }${query}`)"
                    >
					</div>
					<router-link :to="`/qurban/view/${ createSlugLink(item.name, item.id) }${query}`">
					<p style="height: 3rem;overflow: auto;"><strong>{{ item.name }}</strong></p> 
                    <p class="mb-2">
                        <small>
                            {{ item.user ? item.user.name : '-' }}
                        </small>
                    </p>
                    <div class="flex flex-row md:flex-col lg:flex-row items-end justify-between mb-2">
                        <div class="w-2/3 md:w-full lg:w-2/3 mb-0 md:mb-2 lg:mb-0">
                            <h4>

                                <strong class="text-warning">
                                    Rp {{ formatRupiah(item.nominal) }}
                                </strong>
                            </h4>
                        </div>
                        <div class="text-right md:text-left lg:text-right w-1/3 md:w-full lg:w-1/3 overflow-auto">
                            <small><strong>{{ item.berat ? item.berat : '' }}</strong></small>
                        </div>
                    </div>
					</router-link>

				</vx-card>
                </swiper-slide>
                <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
                <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!-- / -->
    </main>
</template>
<script>
import { mapState } from 'vuex'
import 'swiper/dist/css/swiper.min.css'
import { defaultImage } from '@/assets/utils/qurban'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    components: {
        swiper,
	    swiperSlide
    },
    data: () => ({
        swiperOption: {
        	slidesPerView: 4,
            spaceBetween: 30,
            breakpoints: {
               1440: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        },

    }),
    props: {
        datas: {
            required: true
        },
        query: {
            type: String,
            default: ''
        }
    },
    methods: {
        imageLink (qurban) {
            if (qurban.file && qurban.file !== null) {
                return `${process.env.VUE_APP_STORAGE  }/${  qurban.file}`
            }
                        
            return defaultImage
        },
        donationPercent (qurban) {
            return Math.ceil((parseInt(qurban.donasi_terkumpul) / parseInt(qurban.donasi)) * 100)
        }
    }
}
</script>
<style>
	#popular-qurban .vx-card__body {
		padding: 1rem;
	}
</style>